export { default as SVGFill } from './primitives/fill';
export { default as SVGStroke } from './primitives/stroke';
export { default as SVGText } from './primitives/text';
export { default as CheggSVG } from './primitives/svg';
export * from './types';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/svg/index.js
// module id = 6
// module chunks = 12